<template>
  <m-basic-form
    @save="save"
    @remove="remove"
    :loadingMsg="loadingMsg"
    :loadingShow="loadingShow"
    :formId="ID"
  >
    <div class="row">
      <div class="col-5">
        <m-input v-model="form.SENDINGTYPENAME" langlabel="sendingtypename" />
        <m-input
          v-model="form.SENDINGTYPEPRICE"
          type="number"
          langlabel="pricenontax"
        />
        <m-input
          v-model="form.SENDINGTYPETAXRATE"
          type="number"
          langlabel="taxrate"
        />
        <m-yes-no
          v-model="form.ISSTANDARTSENDING"
          langlabel="isstandartsending"
        />
        <m-yes-no v-model="form.ISPAYMENTDOOR" langlabel="ispaymentdoor" />
        <m-yes-no v-model="form.ISACTIVE" langlabel="isactive" />
      </div>
    </div>
  </m-basic-form>
</template>

<script>
import api from "../../api";
import swal from "sweetalert";
export default {
  mounted() {
    if (intval(this.$route.params.id) > 0) {
      this.ID = intval(this.$route.params.id);
      this.getSendingType(this.ID);
    }
  },
  data() {
    return {
      ID: null,
      form: {
        SENDINGTYPENAME: null,
        SENDINGTYPEPRICE: 0,
        SENDINGTYPETAXRATE: 0,
        ISSTANDARTSENDING: 0,
        ISPAYMENTDOOR: 0,
        ISACTIVE: 1,
      },
      loadingShow: false,
      loadingMsg: null,
    };
  },
  methods: {
    save() {
      this.loadingMsg = this.$t("dialog.savingrecord");
      this.loadingShow = true;
      api
        .saveSendingType(
          {
            ...this.form,
            SENDINGTYPEPRICE: toNumberFromTr(this.form.SENDINGTYPEPRICE),
          },
          this.ID
        )
        .then((res) => {
          if (res.data.status) {
            if (this.ID == res.data.data.ID) {
              swal(
                this.$t("dialog.success"),
                this.$t("dialog.successfullyupdatedrecord"),
                "success"
              );
            } else {
              this.ID = res.data.data.ID;
              swal(
                this.$t("dialog.success"),
                this.$t("dialog.successfullysaverecord"),
                "success"
              );
            }
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        })
        .finally(() => {
          this.loadingShow = false;
        });
    },
    getSendingType(id) {
      this.loadingMsg = this.$t("dialog.fetchingdata");
      this.loadingShow = true;
      api
        .getSendingTypeOne(id)
        .then((res) => {
          if (res.data.status && !res.data.msg) {
            const {
              SENDINGTYPENAME,
              SENDINGTYPEPRICE,
              SENDINGTYPETAXRATE,
              ISSTANDARTSENDING,
              ISPAYMENTDOOR,
              ISACTIVE,
            } = res.data.data;
            this.form = {
              SENDINGTYPENAME,
              SENDINGTYPEPRICE: toTrFromNumber(SENDINGTYPEPRICE),
              SENDINGTYPETAXRATE,
              ISSTANDARTSENDING,
              ISPAYMENTDOOR,
              ISACTIVE,
            };
          } else if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        })
        .finally(() => {
          this.loadingShow = false;
        });
    },
    remove() {
      this.loadingMsg = this.$t("dialog.removingrecord");
      this.loadingShow = true;
      api
        .deleteSendingType(this.ID)
        .then((res) => {
          if (res.data.status && res.data.msg) {
            swal(this.$t("dialog.info"), res.data.msg, "info");
          } else {
            swal(
              this.$t("dialog.notice"),
              this.$t("dialog.anerrorhasccurred") + res.data.errMsg,
              "error"
            );
          }
        })
        .catch((err) => {
          swal(
            this.$t("dialog.systemerror"),
            this.$t("dialog.anerrorhasccurred") + err.toString(),
            "error"
          );
        })
        .finally(() => {
          this.loadingShow = false;
        });
    },
  },
};
</script>

<style></style>
